import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/repromaterijali/karticaRolne?`
const API_QR_KOD = `${API_URL}/repromaterijali/updateQRkodRolna`
const auth: UposlenikModel = getAuth()!

const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

// Get request for Kartica rolne dropdown data.
export async function getKarticaRolne(params: any) {
  try {
    const response = await axios.get(API, {headers: headers, params: params})
    if (response.data && response.data.error === 0) {
      return response.data
    } else {
      throw Error(response.data.message)
    }
  } catch (error: any) {
    throw new Error(error.response.data.message)
  }
}

/*export async function updateQRkodRolna(params: any) {
  try {
    const response = await axios.put(API_QR_KOD, {headers: headers, params: params})
    if (response.data && response.data.error === 0) {
      return response.data
    } else {
      console.error('error', response.data.message)
      return response.data.message
    }
  } catch (error: any) {
    throw new Error(error.response.data.message)
  }
}*/

export async function updateQRkodRolna(params: any) {
  try {
    const response = await axios.post(`${API_QR_KOD}?_method=PUT`, params, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

